/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import getVehicles from "../../../actions/vehicles";

class VehicleFilter extends Component {
  componentDidMount() {
    this.props.getVehicles();
  }

  handleVehicleChange = selectedVehicle => {
    if (selectedVehicle) {
      this.props.onChange(selectedVehicle.value);
    } else {
      this.props.onChange("");
    }
  };

  render() {
    const { value } = this.props;
    const vehicleOptions = this.props.vehicles
      .map(vehicle => ({
        value: `${vehicle.id}`,
        label: vehicle.name
      }))
      .sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

    return (
      <Select
        className="filter-select"
        name="vehicle"
        value={value}
        onChange={this.handleVehicleChange}
        options={vehicleOptions}
        placeholder="Filter by vehicle"
        resetValue=""
      />
    );
  }
}
VehicleFilter.propTypes = {
  value: PropTypes.string,
  vehicles: PropTypes.array,
  getVehicles: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
VehicleFilter.defaultProps = {
  value: "",
  vehicles: []
};

const mapStateToProps = state => ({ vehicles: state.vehicles.container });
const mapDispatchToProps = { getVehicles };

export default connect(mapStateToProps, mapDispatchToProps)(VehicleFilter);



// WEBPACK FOOTER //
// ./src/components/runsheets/list/VehicleFilter.js